document.addEventListener('DOMContentLoaded', function() {
    const columns = document.querySelectorAll('.column');
    let lastScrollTop = 0;
    let ticking = false;

    // Configurazione responsive
    const config = {
        desktop: { speed: 0.5, bounce: 2 }, 
        tablet: { speed: 0.3, bounce: 1.5 },
        mobile: { speed: 0.2, bounce: 1 }
    };

    function getDeviceConfig() {
        if (window.innerWidth <= 576) return config.mobile;
        if (window.innerWidth <= 992) return config.tablet;
        return config.desktop;
    }

    function animateColumns(scrollPos) {
        const scrollChange = scrollPos - lastScrollTop;
        const { speed, bounce } = getDeviceConfig();
        
        columns.forEach((column, index) => {
            const scroll = column.querySelector('.scroll');
            const direction = column.classList.contains('scroll-down') ? 1 : -1;
            
            let currentTransform = parseFloat(scroll.getAttribute('data-y') || '0');
            
            // Inverti la direzione dello scroll per le colonne alternate
            const effectiveDirection = index % 2 === 0 ? direction : -direction;
            
            currentTransform += scrollChange * speed * effectiveDirection;
            
            // Aggiungi un "saltellino" quando lo scroll si ferma
            if (Math.abs(scrollChange) < 1) {
                currentTransform += Math.sin(Date.now() / 200) * bounce;
            }
            
            scroll.style.transform = `translateY(calc(-50% + ${currentTransform}px))`;
            scroll.setAttribute('data-y', currentTransform);
        });

        lastScrollTop = scrollPos;
    }

    function handleScroll() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                const scrollPos = window.pageYOffset;
                animateColumns(scrollPos);
                ticking = false;
            });
            ticking = true;
        }
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Inizializza l'animazione
    handleScroll();
});